import { render, staticRenderFns } from "./taskheadInfo.vue?vue&type=template&id=b00736d4&scoped=true&"
import script from "./taskheadInfo.vue?vue&type=script&lang=js&"
export * from "./taskheadInfo.vue?vue&type=script&lang=js&"
import style0 from "./taskheadInfo.vue?vue&type=style&index=0&id=b00736d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00736d4",
  null
  
)

export default component.exports